import { render } from "./VerPersonas.vue?vue&type=template&id=6d8cf1e2"
import script from "./VerPersonas.vue?vue&type=script&lang=js"
export * from "./VerPersonas.vue?vue&type=script&lang=js"

import "./VerPersonas.vue?vue&type=style&index=0&id=6d8cf1e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__